import { api } from "@shared/lib/api";
import {
  ACCOUNT_STATUS,
  AdminUser,
  BackednResponse,
  CreateAdmin,
  GetAdmins,
  PermissionsConst,
} from "@shared/lib/types";

export class AdminService {
  public static async getAdmins(
    limit: number,
    pageNo: number,
    searchQuery?: string,
    accountStatus?: ACCOUNT_STATUS[],
    role?: string[],
    permissions?: string[],
    permissionGroupIds?: string[],
    pricingWorkloadEnrichments: boolean = false
  ) {
    const params = new URLSearchParams();

    if (searchQuery) {
      params.append("searchQuery", searchQuery);
    }

    if (accountStatus && accountStatus?.length) {
      params.append("accountStatuses", accountStatus.join("-"));
    }
    if (role && role?.length) {
      params.append("roles", role.join("-"));
    }
    if (permissions && permissions?.length) {
      params.append("permissions", permissions.join("$$"));
    }
    if (permissionGroupIds && permissionGroupIds?.length) {
      params.append("permissionGroupIds", permissionGroupIds.join("$$"));
    }
    if (pricingWorkloadEnrichments) {
      params.append("pricingWorkloadEnrichments", "true");
    }
    params.append("limit", limit.toString());
    params.append("pageNo", pageNo.toString());

    // Convert params to string and add to URL only if there are parameters
    const queryString = params.toString();
    const url = `user/admin/${queryString ? `?${queryString}` : ""}`;

    const users = (await api.get(url).json()) as BackednResponse<GetAdmins>;

    return users;
  }
  public static async getAdmin(adminId: string) {
    // Convert params to string and add to URL only if there are parameters

    const url = `user/admin/${adminId}`;

    const users = (await api.get(url).json()) as BackednResponse<AdminUser>;

    return users;
  }

  public static async createAdmin(user: CreateAdmin) {
    await api.post("user/admin", {
      json: {
        ...user,
      },
    });
  }

  public static async updateAdmin(userId: string, data: Partial<AdminUser>) {
    return await api
      .patch(`user/admin`, {
        json: {
          userId,
          ...data,
        },
      })
      .json();
  }
  public static async getRoles() {
    const url = `user/admin/roles`;

    const users = (await api.get(url).json()) as BackednResponse<{
      [key: string]: number;
    }>;

    return users;
  }
  public static async getPermissionsConst() {
    const url = `permissions/admin`;

    const users = (await api
      .get(url)
      .json()) as BackednResponse<PermissionsConst>;

    return users;
  }
}
